import { CannedResponse } from '@business/entities/canned';
import { openModal } from '@core/components/ModalStack';
import { Subject } from 'rxjs';
import { SelectCannedResponseProps } from './SelectCannedResponse';

export async function openCannedResponseModal(props: Omit<SelectCannedResponseProps, 'onSelect'>) {
  const { SelectCannedResponse } = await import('./SelectCannedResponse');
  const obs$ = new Subject<CannedResponse>();
  openModal(SelectCannedResponse, {
    ...props,
    onSelect: response => {
      obs$.next(response);
      obs$.complete();
    },
  });
  return obs$.asObservable();
}
